export const UNLIMITED = "Unlimited";
export type NumberOrUnlimited = number | typeof UNLIMITED;
